import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

import { Alert, DialogTitleWithClose } from 'ui';

const validationSchema = Yup.object().shape({
  subject: Yup.string()
    .min('1')
    .max('100')
    .required(),
  message: Yup.string()
    .min('1')
    .max('4000')
    .required(),
});

const useStyles = makeStyles({
  capitalize: {
    textTransform: 'capitalize',
  },
});

const MessageModal = ({ title, jobFunction, open, onClose, onSendMessage }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSubmit = (values, { setSubmitting }) => {
    onSendMessage(values);
    onClose();
    setSubmitting(false);
  };

  const initialValues = {
    subject: '',
    message: '',
    origin: window.location.href,
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitleWithClose onClose={onClose}>
        <span className={classes.capitalize}>
          {title || t(`Contact ${jobFunction || 'advisor'}`)}
        </span>
      </DialogTitleWithClose>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ errors, isSubmitting, touched }) => (
          <Form noValidate>
            <DialogContent>
              <Alert message={t('Your contact details will be taken from your user profile.')} />
              <Field name="subject">
                {({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    label="Subject"
                    error={errors.subject && touched.subject}
                    fullWidth
                  />
                )}
              </Field>
              <Field name="message">
                {({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    label="Message"
                    error={errors.message && touched.message}
                    fullWidth
                    multiline
                    rows={10}
                  />
                )}
              </Field>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={onClose}>
                {t('Cancel')}
              </Button>
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                {t('Send')}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

MessageModal.defaultProps = {
  title: null,
  jobFunction: null,
  open: false,
  onClose: () => null,
  onSendMessage: () => null,
};

MessageModal.propTypes = {
  title: PropTypes.string,
  jobFunction: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSendMessage: PropTypes.func,
};

export default MessageModal;
